












































































































































































import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { RootStoreState } from '../../../../store/store';
import RecaptchaComponent from './../../../../shared/captchaComponent/RecaptchaComponent.vue';
import { State, Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SetTFAModePayload } from '../../../core.store';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { IconConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
@Component({
  components: {
    SwIcon,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwCheckbox,
    RecaptchaComponent,
    SwTextfield,
  },
})
export default class SwTfaDialog extends SwExtendedVue {
  @Prop(String)
  tfaMedium: string;
  @Prop()
  value: any;
  @Prop()
  email: any;
  @Prop()
  showRememberMe: Boolean;
  @Prop()
  isCaptchaNeeded: boolean;
  @Prop()
  showTFADialog: Boolean;
  @State((state: RootStoreState) => state.CoreStoreModule.tfaMode)
  readonly tfaMode:boolean;

  @Mutation
  setTfaMode: VuexMappedMutation<SetTFAModePayload>;

  captchaResponse: string = '';

  emailCodeClicked: boolean = false;
  tfaCode: string = '';
  tfaCodeError: boolean = false;
  maskedInputType: string = 'password';
  showInputError: boolean = false;
  errorMessage: string = '';
  rememberMeValue: boolean = false;
  iconConfig: IconConfig = {
    name: 'view',
    size: '18px',
    color: '#868686',
  };

  emailTFACode() {
    this.emailCodeClicked = true;
    this.tfaCode = '';
    this.tfaCodeError = false;
    this.setTfaMode({ mode: 'EMAIL' });
    const obj = {
      username: this.$store.getters.getUserId,
      authmode: this.tfaMode,
      password: this.value.password,
      clientId: this.$store.getters.getClientId,
    };
    this.$store.dispatch('sendEmail', obj)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          messageService.messageManager.showMessage('login-message',  res.msgDesc , 'success');
          if (res.content && res.content.TFAID) {
            localStorage.setItem('TFAID', res.content.TFAID.toString());
          }
        } else {
          messageService.messageManager.showMessage('login-message',  res.msgDesc , 'failed');
        }
      });
  }
  resendTFACode() {
    this.tfaCodeError = false;
    this.tfaCode = '';
    this.$emit('resendToken');
  }
  verifyTFA() {
    if (this.isCaptchaNeeded) {
      let result: { status: string; response: string; msg: string; } = { status: '', response: '', msg: '' };
      result = (this.$refs['recaptchaComponent'] as RecaptchaComponent)?.fetchCaptcha() || { status: '', response: '', msg: '' };
      if (result && result.status === 'error') {
        messageService.messageManager.showMessage('login-message',  result?.msg , 'failed');
        return;
      }
      this.captchaResponse = result.response ? result.response : '';
    } else {
      this.captchaResponse = '';
    }
    if (this.tfaCode === '') {
      this.tfaCodeError = true;
    } else {
      const TFAID: any = localStorage.getItem('TFAID');
      const obj = {
        username: this.$store.getters.getUserId,
        authmode: this.tfaMode,
        password: this.value.password,
        clientId: this.$store.getters.getClientId,
        authkey: this.tfaCode.trim(),
        TFACode: this.tfaCode.trim(),
        captchaText: this.captchaResponse ? this.captchaResponse : '',
        rememberMe: this.rememberMeValue ? 'TRUE' : 'FALSE',
        TFAID: TFAID ? TFAID : '',
      };
      this.$store.dispatch('verifyTFA', obj)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'NOK') {
            messageService.messageManager.showMessage('login-message', res.msgDesc , 'failed');
          }
          if (res.operationStatus === 'OK') {
            if (res.content.deviceCode && res.content.deviceCode !== null) {
              localStorage.setItem('deviceCode',  res.content.deviceCode);
            }
            this.$store.commit('mutate', { property: 'isGuestBuyNowUser', with: false });
            this.$store.commit('mutate', { property: 'loggedIn', with: true });
            this.$store.dispatch('preserveUserInfo', res);
            if (res.content.changePassword && res.content.changePassword === 'YES') {
              this.$emit('showChangePassword');
            } else {
              this.goToDashboard();
            }
          }
        })
        .catch((error: any) => {
          messageService.messageManager.showMessage('login-message', error.message , 'failed');
        });
    }
  }
  showError(msg: any) {
    this.showInputError = true;
    this.errorMessage = msg;
    setTimeout(() => { this.showInputError = false; this.errorMessage = ''; }, 3000);
  }
  setCookie(cookieKey: any, cookieValue: any) {
    this.removeCookie(cookieKey)
    .then(() => {
      document.cookie = `${cookieKey}=${cookieValue}`;
    });
  }
  removeCookie(cookieKey: any) {
    return new Promise((resolve: any, reject: any) => {
      console.warn(reject);
      document.cookie = `${cookieKey}=`;
      resolve(true);
    });
  }
  closeDialog() {
    this.captchaResponse = '';
    this.tfaCode = '';
    this.$emit('closeTFADialog');
  }
  goToDashboard() {
    const TFAID: any = localStorage.getItem('TFAID');
    if (TFAID) {
      localStorage.removeItem('TFAID');
    }
    if (this.$route.query.loginmode &&
      this.$route.query.loginmode.toString() === 'guestbuynow') {
      this.$router.push({ path:'/m/feature/cart' });
    } else {
      this.$router.push({ path:'/m/feature/dashboard' });
    }
  }
  mounted() {
    this.setupTextField('verificationcode');
    this.makeFocus('verificationcode');
  }
  makeFocus(ref: string) {
    this.$nextTick(() => {
      if ((this.$refs[ref] as SwTextfield)) {
        (this.$refs[ref] as SwTextfield).focus();
      }
    });
  }

  setupTextField(ref: string) {
    this.$nextTick(() => {
      if ((this.$refs[ref] as SwTextfield)) {
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.setAttribute('style', 'cursor: pointer');
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.classList?.add('eyeIconClass');
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.addEventListener('click', () => {
           // tslint:disable-next-line
          (this.$refs[ref] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'text');
        });
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.addEventListener('mouseout', () => {
           // tslint:disable-next-line
          (this.$refs[ref] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'password');
        });
      }
    });
  }
}
